import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { I18n } from "@aws-amplify/core";
import { get, size, filter, join, map } from "lodash";
import moment from "moment-timezone";

import Grid from "@material-ui/core/Grid";

import PrintContainer from "../../Common/PrintContainer";

import { formatDate } from "../../../utils/date";
import { calendarViews } from "../../../constants/common";

const styles = {
  info: {
    marginRight: "30px",
  },
  label: {
    fontWeight: 500,
    marginRight: "5px",
  },
};

const SchedulerCalendarWeeklyPrint = (props) => {
  const { classes, companies, filters } = props;

  const site = get(
    filter(
      get(
        filter(
          companies,
          (c) =>
            size(
              filter(get(c, ["sites"]), (s) => s.id === get(filters, ["site"]))
            ) > 0
        ),
        [0, "sites"]
      ),
      (s) => s.id === get(filters, ["site"])
    ),
    [0]
  );

  const renderZones = () => {
    if (size(get(filters, ["zones"])) === 0) return I18n.get("common_all");
    return join(
      map(get(filters, ["zones"]), (z) =>
        get(
          filter(get(site, ["zones"]), (sz) => sz.id === z),
          [0, "name"]
        )
      ),
      ", "
    );
  };

  return (
    <PrintContainer>
      <Grid container direction="column">
        <Grid item style={{ marginLeft: "42px", marginBottom: "5px" }}>
          <Grid container>
            <Grid item className={classes.info}>
              <span className={classes.label}>
                {I18n.get("profiles_site")}:
              </span>
              <span>{get(site, ["name"])}</span>
            </Grid>
            <Grid item className={classes.info}>
              <span className={classes.label}>
                {I18n.get("dashboard_zones")}:
              </span>
              <span>{renderZones()}</span>
            </Grid>
            <Grid item className={classes.info}>
              <span className={classes.label}>
                {I18n.get("dashboard_date")}:
              </span>
              <span>
                {`${formatDate(get(filters, ["startDate"]), "DD/MM")} ${
                  get(filters, ["calendarView"]) === calendarViews.weekly
                    ? `- ${formatDate(
                        moment(get(filters, ["startDate"])).add(7, "d"),
                        "DD/MM"
                      )}`
                    : ""
                }`}
              </span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>{props.children}</Grid>
      </Grid>
    </PrintContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: get(state, ["user", "companies"]),
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(SchedulerCalendarWeeklyPrint)
);
